import { ComponentType, isValidElement, VNode } from 'preact';
import { PropsWithChildren } from 'preact/compat';

export function wrapWithComponent<TProps extends PropsWithChildren>(
  element: VNode,
  Component: ComponentType<TProps>,
  props: TProps & JSX.IntrinsicAttributes,
) {
  if (element === null) {
    return null;
  }

  return isElementOfType(element, Component) ? (
    element
  ) : (
    <Component {...props}>{element}</Component>
  );
}

export function isElementOfType<TProps>(
  element: VNode,
  Component: ComponentType<TProps>,
) {
  if (
    element === null ||
    !isValidElement(element) ||
    typeof element.type === 'string'
  ) {
    return false;
  }

  const { type } = element;

  return typeof type !== 'string' && Component === type;
}
